import React from 'react';
import '../styles/PageLoader.css';

/**
 * PageLoader - A beautiful, reusable loading component
 * 
 * @param {Object} props
 * @param {boolean} props.fullPage - Whether to cover the full page (default: true)
 * @param {string} props.message - Optional loading message
 * @param {string} props.variant - 'default' | 'minimal' | 'dots' | 'pulse'
 * @param {string} props.size - 'sm' | 'md' | 'lg'
 * @param {string} props.className - Additional CSS class
 */
const PageLoader = ({ 
    fullPage = true, 
    message = '', 
    variant = 'default',
    size = 'md',
    className = ''
}) => {
    const containerClass = `page-loader ${fullPage ? 'page-loader--full' : 'page-loader--inline'} page-loader--${size} ${className}`.trim();

    const renderLoader = () => {
        switch (variant) {
            case 'dots':
                return (
                    <div className="page-loader__dots">
                        <span className="page-loader__dot"></span>
                        <span className="page-loader__dot"></span>
                        <span className="page-loader__dot"></span>
                    </div>
                );
            case 'pulse':
                return (
                    <div className="page-loader__pulse">
                        <div className="page-loader__pulse-ring"></div>
                        <div className="page-loader__pulse-ring"></div>
                        <div className="page-loader__pulse-core"></div>
                    </div>
                );
            case 'minimal':
                return <div className="page-loader__spinner page-loader__spinner--minimal"></div>;
            default:
                return (
                    <div className="page-loader__content">
                        <div className="page-loader__spinner-wrapper">
                            <div className="page-loader__spinner">
                                <div className="page-loader__spinner-blade"></div>
                                <div className="page-loader__spinner-blade"></div>
                                <div className="page-loader__spinner-blade"></div>
                                <div className="page-loader__spinner-blade"></div>
                                <div className="page-loader__spinner-blade"></div>
                                <div className="page-loader__spinner-blade"></div>
                                <div className="page-loader__spinner-blade"></div>
                                <div className="page-loader__spinner-blade"></div>
                            </div>
                        </div>
                        {message && <p className="page-loader__message">{message}</p>}
                    </div>
                );
        }
    };

    return (
        <div className={containerClass}>
            <div className="page-loader__backdrop"></div>
            <div className="page-loader__container">
                {renderLoader()}
                {variant !== 'default' && message && (
                    <p className="page-loader__message">{message}</p>
                )}
            </div>
        </div>
    );
};

export default PageLoader;

